import React, { Suspense, useState } from "react";
// @material
import { Stack } from "@mui/material";
// components
import AssetViewerTable from "./AssetListViewer/AssetTable";
import AssetViewerHeader from "./Header/Title";
import AssetViewerTabs from "./Tabs";
import Page from "@components/Page";
import LoadingScreen from "@components/LoadingScreen";
import { SideBar } from "../../comparison/SideBar";
import { PageTitle } from "@components/ui/styles";

// ----------------------------------------------------------------------

function RealityIndexPage() {
  const [checkedAssets, setCheckedAsset] = useState<Array<Object>>([]);

  return (
    <>
      <Page title="부동산 지수 종목 탐색">
        <Stack spacing={2}>
          <PageTitle>부동산 지수 종목 탐색</PageTitle>
          <AssetViewerTable
            onSelectAsset={(e) => {
              setCheckedAsset([e, ...checkedAssets]);
            } } onChangeChecked={()=> {}}          />
          <Suspense fallback={<LoadingScreen />}>
            <AssetViewerHeader />
            <AssetViewerTabs />
          </Suspense>
        </Stack>
        <SideBar
          assetType="realty"
          market="realty_indexes"
          checkedAssets={checkedAssets.map((v) => {
            // 장바구니가 assetId 로 중복을 거른다. 없으면 한 종목만 남는다.
            return { ...v, assetId: v["rf_id"], name: v["asset_name"] };
          })}
          enableDownload={false}
          onChange={setCheckedAsset}
        />
      </Page>
    </>
  );
}

export default React.memo(RealityIndexPage);
